import { logDevelopmentError } from './logDevelopmentError';

export const POST_MESSAGES = {
  OPEN_TABLE: 'open_table',
  CASHIER: 'cashier',
  CLOSE_GAME: 'close_game',
  RC_CHOICE: 'rc_choice',
};

export const postMessage = (params: Record<string, unknown> = {}, stringify = true) => {
  try {
    const parent = window.opener || window.parent;

    if (!parent) return;
    parent.postMessage(stringify ? JSON.stringify(params) : params, '*');
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn(`Post message failed for ${params.msg ?? 'unknown event' }`, e);

    if (e instanceof Error) {
      logDevelopmentError(e?.message);
    }
  }
};
